import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import Ci from './ci';
import CiCliente from './ciCliente';

/**
 * Componente principal que controla a exibição das tabelas de processos
 * com base no nível de acesso do usuário.
 */
function Controle() {
    const [authenticated, setAuthenticated] = useState(false);
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const token = Cookies.get('ANers');
    console.log(token)

    useEffect(() => {
        // Verifica se o token está presente
        // if (token) {
            // Faz uma requisição para a API para verificar a autenticação
            axios.post('/api/getprocess', { withCredentials: true })
                .then((res) => {
                    if (res.data.auth === true) {
                        setAuthenticated(true);
                        setUserData(res.data);
                    } else {
                        navigate('/login');
                        console.log(res.data)
                    }
                })
                .catch((error) => {
                    console.error('Erro na autenticação:', error);
                     navigate('/login');
                })
                .finally(() => {
                    setLoading(false);
                });
        //} else {
            // Redireciona para a página de login se não houver token
            // navigate('/login');
            //alert("erro controle token")

        //}
    }, [navigate]);

    if (loading) {
        // Exibe um spinner de carregamento enquanto verifica a autenticação
        return (
            <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh"
            }}>
                <div className="spinner-border" role="status">
                    <span className="sr-only">Carregando...</span>
                </div>
            </div>
        );
    }

    if (!authenticated) {
        // Redirecionamento já foi tratado no useEffect
        return null;
    }

    // Decide qual componente renderizar com base no nível de acesso
    if (userData.nivel === "Aners") {
        return <Ci response={userData} />;
    } else {
        return <CiCliente response={userData} />;
    }
}

export default Controle;
